<template>
  <div class="app-download">
    <a href="https://vntopnews.onelink.me/i9ii?pid=news_official&c=news_official" target="_blank" rel="noopener noreferrer"></a>
  </div>
</template>
<script>
export default {
};
</script>
<style lang="stylus" scoped>
  .app-download
    display none
    width 112px
    height 162px
    background-image url(../assets/image/vn_new.png), url(../assets/image/vn_as.png), url(../assets/image/vn_gp.png)
    background-size 100%, 76px, 76px
    background-repeat no-repeat
    background-position-x 0, 18px, 18px
    background-position-y 0, 112px, 139px
    position fixed
    right 0
    top 50%
    transform translateY(-50%)
    &>a
      display block
      width 100%
      height 100%
</style>



// WEBPACK FOOTER //
// Download.vue?1fc76490